import $ from 'jquery'
import is from '../is'
import common from '../common'
import index from './index'

export const get = (project, returnOnly, forceSync) => {
    return index.info(project, returnOnly, forceSync)
}

export const legalDocs = (project, cmd) => {
    if(cmd === 'cached')
        return index.files(project, 'legal', true)
    
    return index.files(project, 'legal', {
        linkedTo: 'legal',
        linksInfo: 4,
        total: 500,
        order: 'asc',
        forceSync: cmd === 'forceSync'
    }, cmd === 'reFetch' || cmd === 'forceSync')
}

export const update = (project, data) => {
    let wait = $.Deferred()
    
    let payload = $.extend(true, {}, data, {
        action: 'details.update',
        resultKey: 'status'
    })
    
    payload = {
        request: [payload]
    }
    
    index.update(project, payload).then(
        (r) => {
            if(r.result.status !== 'success')
                return wait.reject(r.result.status).promise()
            
            get(project, false).then(
                (r) => {
                    return wait.resolve(r).promise()
                },
                (err) => {
                    return wait.reject(err).promise()
                }
            )
        },
        (err) => {
            return wait.reject(err).promise()
        }
    )
    
    return wait.promise()
}

export const getAllowedFieldsToEdit = (projectInfo) => {
    if(!projectInfo.permissions)
        return {}
    
    let out = {}
    
    $.each(projectInfo.permissions.details, (k, v) => {
        out[v] = is.value(v, projectInfo)
    })
    
    return out
}

export const mapViewLink = (projectInfo) => {
    let url = 'https://maps.google.com/maps?q=loc:'
    
    let v = is.value('address.geoPoints.latitude', projectInfo)
    
    if(v)
        v = projectInfo.address.geoPoints.latitude+','+projectInfo.address.geoPoints.longitude
    else {
        v = projectInfo.address.address1
        
        if(projectInfo.address.address2)
            v += ', '+projectInfo.address.address2
        
        v += ', '+projectInfo.address.city+' - '+projectInfo.address.postalCode
        
        if(projectInfo.address.state)
            v += ', '+common.getStateName(projectInfo.address.country, projectInfo.address.state)
        
        v += ', '+common.getCountryName(projectInfo.address.country)
    }
    
    return url+encodeURIComponent(v)
}

export const uploadLegal = (project, formName, file) => {
    let data = new FormData()
    data.append('data', file)
    
    return common.apiFileUpload({
        projectId: index.id(project.id),
        linkedTo: 'legal',
        linkedId: formName
    }, data)
}

export default {
    get, update, mapViewLink,
    getAllowedFieldsToEdit, legalDocs,
    uploadLegal
}
